import React from 'react';
import ReactDOM from 'react-dom';
import { init } from 'pp-react-l10n';
import ArticleDemo from './container/ArticleDemo.js';
import HomeMainComponent from './components/HomeMainComponent.js';
import CategoriesMainComponent from './components/CategoriesMainComponent.js';
import ArticleMainComponent from './components/ArticleMainComponent.js';
import ThankyouMainComponent from './components/ThankyouMainComponent';

init({
  content: {
    staticContent,
  },
});

function countryCode(country) {
  if (country === 'GB') {
    country = 'UK';
  }
  return country;
}

if (pageName === 'home') {
  ReactDOM.hydrate(
    <HomeMainComponent
      carouselInfo={carouselInfo}
      userAccountInfo={userAccountInfo}
      encryptedAccountNumber={encryptedAccountNumber}
      topicsInfo={topicsInfo}
      isPopArticleEnabled={isPopArticleEnabled}
      legalFooter={legalFooter}
      locale={locale}
      country={countryCode(dataLayer.contentCountry)}
      tilesInfo={tilesInfo}
      colors={colors}
      totalArticles={totalArticles}
      topicsHash={topicsHash}
      isLoggedIn={isLoggedIn}
      isNewMppEnabled={isNewMppEnabled}
      helpContainer={helpContainer}
    />,
    document.querySelector('#homeMain-container'),
  );
}

if (pageName === 'categories') {
  ReactDOM.hydrate(
    <CategoriesMainComponent
      resultsInfo={resultsInfo}
      userAccountInfo={userAccountInfo}
      encryptedAccountNumber={encryptedAccountNumber}
      sections={leftnavData}
      popArticlesHomeInfo={popArticlesHomeInfo}
      legalFooter={legalFooter}
      isPopArticleEnabled={isPopArticleEnabled}
      locale={locale}
      country={countryCode(dataLayer.contentCountry)}
      totalResultsList={totalResultsList}
      topicsHash={topicsHash}
      topics={leftnavData}
      refID={refID}
      isHomeBtnEnabled={isHomeBtnEnabled}
      isLoggedIn={isLoggedIn}
      isNewMppEnabled={isNewMppEnabled}
      helpContainer={helpContainer}
    />,
    document.querySelector('#categoriesmain-container'),
  );
}

if (pageName === 'article') {
  ReactDOM.hydrate(
    <ArticleMainComponent
      name="Social"
      articleInfo={articleInfo}
      userAccountInfo={userAccountInfo}
      encryptedAccountNumber={encryptedAccountNumber}
      topicsHash={topicsHash}
      gatewayInfo={gatewayInfo}
      isPopArticleEnabled={isPopArticleEnabled}
      legalFooter={legalFooter}
      popArticlesHomeInfo={popArticlesHomeInfo}
      locale={locale}
      country={countryCode(dataLayer.contentCountry)}
      isRatingEnabled={isRatingEnabled}
      isHomeBreadcrumbEnabled={isHomeBreadcrumbEnabled}
      isLoggedIn={isLoggedIn}
      isNewMppEnabled={isNewMppEnabled}
      helpContainer={helpContainer}
      isECMLive={isECMLive}
    />,
    document.querySelector('#articleMainContainer'),
  );
}

if (pageName === 'thankyou') {
  ReactDOM.render(
    <ThankyouMainComponent
      userAccountInfo={userAccountInfo}
      encryptedAccountNumber={encryptedAccountNumber}
      isPopArticleEnabled={isPopArticleEnabled}
      legalFooter={legalFooter}
      locale={locale}
      country={countryCode(dataLayer.contentCountry)}
      tilesInfo={tilesInfo}
      categorieValues={categorieValues}
      colors={colors}
      totalArticles={totalArticles}
      topicsHash={topicsHash}
      isNewMppEnabled={isNewMppEnabled}
      isLoggedIn={isLoggedIn}
      helpContainer={helpContainer}
    />,
    document.querySelector('#thankyouMainContainer'),
  );
}

if (pageName === 'apiview') {
  ReactDOM.render(<ArticleDemo />, document.querySelector('#article-view'));
}
